import firebase from "../../Firebase";
import { FirebaseCollections } from "enums";

const firestoreApi = firebase.firestore();

const getNextCorteId = async () => {
  try {
    let recordId = null;
    const record = await firestoreApi
      .collection(FirebaseCollections.Corte)
      .orderBy("order", "desc")
      .limit(1)
      .get();

    record.forEach((doc) => {
      recordId = Number(doc.id) + 1;
    });

    return recordId;
  } catch (e) {
    console.log(e.message);
  }
};

const pickTelaFieldsForCorte = (tela) => ({
  b: tela.b ? tela.b : null,
  cx: tela.cx ? tela.cx : null,
  ft: tela.ft ? tela.ft : null,
  hc: tela.hc ? tela.hc : null,
  hojaConsumo: tela.hojaConsumo ? tela.hojaConsumo : null,
  moldes: tela.moldes ? tela.moldes : null,
  moldesUrl: tela.moldesUrl ? tela.moldesUrl : null,
});

const createCorteRecord = async (corteData) => {
  const recorId = await getNextCorteId();
  try {
    const corte = await firestoreApi
      .collection(FirebaseCollections.Corte)
      .doc(String(recorId))
      .set({
        ...corteData,
        index: String(recorId),
        order: Number(recorId),
      });
    return corte;
  } catch (e) {
    console.log(e.message);
  }
};

export { getNextCorteId, createCorteRecord, pickTelaFieldsForCorte };
